// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3yF_F","title":"InfoRow_title__26TaW"};